<template lang='pug'>
section.cadastro-territorio
    BaseHeader(:titulo="$t('mensagens.territorio.titulo')", :exibeBotao='false', :voltarPara='true')

    .view-container-base-header
        .row.m-0
            el-form.formContainer.w-100.mb-3
                h2 {{ $t('mensagens.territorio.informacoesCadastrais') }}
                    .form-alignment
                        el-form-item.form-size.separator.my-3(
                            :label="$t('mensagens.territorio.labels.nomeFazenda')",
                            :rules='[{ required: true, trigger: "blur" }]'
                        )
                            el-input(
                                v-model='territorio.nome',
                                @blur='$v.territorio.nome.$touch()',
                                :label="$t('mensagens.territorio.labels.nomeFazenda')",
                                :class='{ "error-border": $v.territorio.nome.$error }',
                                maxlength='250'
                            )
                            .error(
                                v-if='$v.territorio.nome.$error && !$v.territorio.nome.required'
                            ) {{ $t('mensagens.territorio.nomeNecessario') }}
                        el-form-item.form-size.mb-0(:label="$t('mensagens.territorio.labels.certificacoes')")
                            el-select.w-100(
                                v-model='territorio.certificacoes',
                                multiple,
                                :placeholder="$t('mensagens.comuns.selecione')",
                                value-key='id'
                            )
                                el-option(
                                    v-for='tipo in tipoCertificacao',
                                    :key='tipo.id',
                                    :value='tipo',
                                    :label='tipo.nome'
                                ) {{ tipo.nome }}
                        el-form-item.mb-0.ml-4(v-if='ff1183CodigoLyraTerritorio && territorio.codigoLyra',
                            :label="$t('mensagens.territorio.labels.codigoLyra')",
                            style='width: 35%;')
                            el-input(
                                v-model='territorio.codigoLyra',
                                disabled=true
                            )
                    el-form-item.mb-0(:label="$t('mensagens.territorio.pessoaVinculada')")
                        el-select.w-100(
                            v-model='territorio.representantes',
                            multiple,
                            :placeholder="$t('mensagens.comuns.selecione')",
                            filterable,
                            remote,
                            reserve-keyword,
                            :remote-method='remoteMethod',
                            :loading='loading',
                            @change='handleChangeSelectInput($event)',
                            value-key='id',
                            ref='elselectinput',
                            :disabled="isEdicaoSimplesTerritorio"
                        )
                            el-option(
                                v-for='representante in options',
                                :key='"representante" + representante.id',
                                :value='representante',
                                :label='representante.nomeRazaoSocial'
                            ) {{ representante.nomeRazaoSocial }}
                    el-form-item.form-size.separator.my-3(
                        :label="$t('mensagens.territorio.labels.idDoCliente')"
                    )
                        el-input(
                            v-model='territorio.idCliente',
                            @blur='$v.territorio.idCliente.$touch()',
                            @input='verificaInputBarra($event)',
                            :placeholder="$t('mensagens.territorio.labels.idDoCliente')",
                            maxlength='40',
                            show-word-limit
                        )
                ComercializacaoTerritorio(
                    v-if='dataLoaded',
                    :comercializacaoSelected='territorio.comercializacoes'
                )

        .row.m-0.mb-3
            .col-4.formContainer
                h2.text-left.py-4 {{ $t('mensagens.territorio.informacoesEspaciais') }}

                el-collapse(accordion, v-model='activeForms')
                    el-collapse-item(
                        :title="$t('mensagens.territorio.inserirPorNumeroCarDocumentoParcelaOuIncra')",
                        name='CASE1',
                        style='border-bottom: 1px solid #ebeef5',
                        :disabled='isEdicaoSimplesTerritorio'
                    )
                        .row.m-0.d-flex.flex-row
                            el-input#carCodigo.mr-2(
                                type='text',
                                v-model='carCodigo',
                                :placeholder="$t('mensagens.territorio.numeroCarDocumentoParcelaOuIncra')",
                                style='width: 100%'
                            )
                                i.el-input__icon.el-icon-info(
                                    slot='suffix',
                                    :title="$t('mensagens.blocoFiltros.infos.pesquisarCarDocumento')"
                                )
                        .row.m-0.d-flex.flex-row-reverse
                            BaseButton.btn.btn-primary.row.my-2.mx-2(
                                style='width: auto',
                                type='primary',
                                @click='findCar'
                            )
                                | {{ $t('mensagens.comuns.adicionar') }}

                    el-collapse-item(
                        :title="$t('mensagens.territorio.uploadArquivosVetoriais')",
                        name='CASE2',
                        :disabled='isEdicaoSimplesTerritorio'
                    )
                        .row.m-0.d-flex.flex-row
                        el-upload.upload-demo(
                            drag,
                            :file-list='fileList',
                            action='alert',
                            :auto-upload='false',
                            :on-change='onLoadFile',
                            :on-remove='onRemoveFile',
                            ref='upload'
                        )
                            i.el-icon-upload(style='margin-top: 40px')
                            .el-upload__text {{ $t('mensagens.territorio.dragAndDrop.1') }} <em>{{ $t('mensagens.territorio.dragAndDrop.2') }}</em>

                    el-collapse-item(
                        :title="$t('mensagens.territorio.selecionarImovelCarMapa')",
                        name='CASE3',
                        :disabled='isEdicaoSimplesTerritorio'
                    )
                        .row.my-2.mx-0
                            el-row.pt-3
                                p {{ $t('mensagens.territorio.aposAtivarCamadaCliqueSobreLocalizacaoRural') }}
                                el-col
                                    BaseButton.large.w-100(
                                        :type='tipoBotao',
                                        @click='toggleSelecao'
                                    )
                                        .btn-selecao-mapa-body
                                            i.mdi.mdi-layers
                                            span {{ textoBotao }}

            .col-8.pr-0
                .mapa
                    mapa.map-content(
                        :mapLayersConfigs='layersMaps',
                        :mapConfig='mapConfig',
                        :idMapa='"mapaAddTerritorio"',
                        :height='"625px"',
                        @draw-created='adicionarDesenho',
                        @draw-edited='desenhosAlterados',
                        @removerTerritorio='removerTerritorio',
                        :deslocarPopup='true',
                        :menuMaior='true',
                        :cadastroTerritorio='true',
                        ref='mapa'
                    )

        .row
            listAreasTable(
                @delete-upload-file='deleteUploadFile',
                @click-delete-area='clearSobreposicaoTerritorio',
                :desabilitarAcoes='isEdicaoSimplesTerritorio'
                ref='table'
            )

        .row.justify-content-end.py-3.m-0
            el-tooltip(
                effect='dark',
                :content="$t('mensagens.territorio.preenchaCamposObrigatorios')",
                placement='top-start',
                :class='{ "item btn-disabled": this.$v.$invalid || this.territoryTableData.length !== 1 || this.territorioSobrePostoMessage }',
                :disabled='!(this.$v.$invalid || this.territoryTableData.length !== 1)'
            )
                BaseButton(
                    v-if='this.isAdding',
                    type='primary',
                    @click='addTerritorio',
                    style='width: 104px'
                )
                    | {{ $t('mensagens.comuns.cadastrar') }}
                BaseButton(
                    v-else,
                    type='primary',
                    @click='updateTerritorio',
                    style='width: 80px'
                )
                    | {{ $t('mensagens.comuns.salvar') }}

    div(v-if='dialogListaCarSelect')
        ModalSelecionarCarsSobrepostos(
            :show='dialogListaCarSelect',
            :cars='Array.from(carsSet)',
            :geometriaTerritorio='territorio.geoJson',
            :firstCars='firstCarsSelected ? Array.from(firstCarsSelected) : []',
            :carEspecificado='carEspecificado',
            @voltar='dialogListaCarSelect = false',
            @salvar='savarCarsVinculados',
            @ignorar-todos='ignorarTodosCars'
        )

    div(v-if='mostrarModalDadosCpfCnpj')
        ModalSelecionarDadosCpfCnpj(
            :show='mostrarModalDadosCpfCnpj',
            :cpfCnpj='carVinculadoCpfCnpj',
            tipo='TERRITORIO',
            :dados='dados',
            @voltar='mostrarModalDadosCpfCnpj = false',
            @retornarDadosSelecionados='adicionarDadosSelecionadosNaModalNoMapa'
        )

    el-dialog.dialog-lista-select(
        :visible.sync='territorioSobrePosto',
        :title='$t("mensagens.territorio.territorioSobreposto")',
        :close-on-click-modal='false',
        :close-on-press-escape='true',
        :destroy-on-close='true',
        :show-close='true',
        width='30%'
    )
        p.pre-formatted {{ internacionalizarMensagens(this.territorioSobrePostoMessage) }}
        .d-flex.flex-direction.justify-content-between.posicao-botao
            BaseButton(slot='footer', size='mini', @click='closeDialog') {{ $t('mensagens.comuns.voltar') }}
            BaseButton(
                slot='footer',
                size='mini',
                type='primary',
                @click='continuarTerritorioSobreposto'
            ) {{ $t('mensagens.comuns.continuar') }}

    modal-vincular-car-obrigatorio-territorio(
        :show='modalVincularCar.mostrarModalVincularCar'
        :payload='modalVincularCar.payload'
        @close="modalVincularCar.mostrarModalVincularCar = false"
        @delete-upload-file='deleteUploadFile',
        @click-delete-area='clearSobreposicaoTerritorio',
    )

    ModalCriarNovosMonitoramentos(
        :mostrar='showModalCriarNovosMonitoramentos',
        :data='getRecriarMonitoramentos',
        @fechar='fecharModalCancelarMonitoramentos',
        @criarNovoMonitoramento='criarNovoMonitoramento'
    )

    ModalCancelarMonitoramentos(
        :mostrar='showModalCancelarMonitoramentos',
        :data='getRecriarMonitoramentos',
        @fechar='showModalCancelarMonitoramentos = false',
        @continuar='salvarTerritorio'
    )

    ModalErroRecriarMonitoramentos(
        :mostrar='showModalErroRecriarMonitoramentos',
        :data='monitoramentosComErro',
        @fechar='fecharModalErroRecriarMonitoramentos'
    )
</template>

<script>
import ModalCriarNovosMonitoramentos from '@/components/territorio/ModalCriarNovosMonitoramentos.vue';
import ModalCancelarMonitoramentos from '@/components/territorio/ModalCancelarMonitoramentos.vue';
import ModalErroRecriarMonitoramentos from '@/components/territorio/ModalErroRecriarMonitoramentos.vue';
import { required } from 'vuelidate/lib/validators';
import { get } from 'lodash';
import L from 'leaflet';
import { mapActions, mapGetters } from 'vuex';
import BaseHeader from '@/components/BaseHeader';
import EmptyResult from '@/components/EmptyResult';
import territorioService from '@/services/TerritorioService';
import LocalidadeService from '@/services/LocalidadeService';
import representanteService from '@/services/RepresentanteService';
import MonitoramentoService from '@/services/MonitoramentoService';
import Mapa from '@/components/MapaLeaflet';
import listAreasTable from '@/components/listAreasTable/ListAreasTable';
import geometryConverter from '@/utils/conversorGeometrias';
import formatters from '@/utils/formatters';
import validators from '@/utils/validators';
import geometryUtils from '@/utils/mapa/geometry.js';
import ModalSelecionarCarsSobrepostos from '@/components/territorio/ModalSelecionarCarsSobrepostos';
import mapaEstilos from '@/utils/mapa/mapa.estilos';
import EventBus from '@/utils/eventBus';
import ComercializacaoTerritorio from '@/components/territorio/Comercializacao';
import ModalSelecionarDadosCpfCnpj from '@/components/ModalSelecionarDadosCpfCnpj';
import MunicipioService from '@/services/MunicipioService';
import CarService from '@/services/car/CarService';
import SigefService from '@/services/SigefService';
import ModalVincularCarObrigatorioTerritorio from '@/components/territorio/ModalVincularCarObrigatorioTerritorio.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import { formatFlag } from '@/utils/featureFlags/featureFlag';
import { FeatureFlagConst } from '@/constants/FeatureFlag';
import TipoMonitoramento from '@/constants/TipoMonitoramento';

export default {
    name: 'CadastrarEditarTerritorio',
    components: {
        ModalVincularCarObrigatorioTerritorio,
        BaseHeader,
        EmptyResult,
        Mapa,
        listAreasTable,
        ModalSelecionarCarsSobrepostos,
        ComercializacaoTerritorio,
        ModalSelecionarDadosCpfCnpj,
        ModalCriarNovosMonitoramentos,
        ModalCancelarMonitoramentos,
        ModalErroRecriarMonitoramentos,
        BaseButton
    },
    data() {
        return {
            dataLoaded: false,
            modalVincularCar: {
                mostrarModalVincularCar: false,
                payload: null
            },
            isAdding: null,
            isAddingOrEditingTerritorio: true,
            isIgnoreSobreposition: false,
            territorio: {
                nome: null,
                representantes: [],
                city: null,
                state: null,
                area: null,
                comercializacoes: null,
                certificacoes: null,
                idCliente: null
            },
            addTerritorioSuccess: false,
            selectedTerritorio: {},
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    popupControl: true,
                    drawControl: true,
                    fullscreen: true
                },
                inspecionar: true,
                dontZoomIn: true,
                fitBounds: true,
                addLimitesEstado: false
            },
            actionType: 'Cadastrar',
            activeForms: [],
            estados: [],
            estadoSelecionado: null,
            municipios: [],
            municipioSelecionado: null,
            fileList: [],
            representanteData: [],
            representanteSelecionado: null,
            pageToFetch: 0,
            ativo: false,
            resultados: [],
            geometria: null,
            loading: false,
            options: [],
            sendToMonitormanetoModal: false,
            paginacao: {
                paginaAtual: 1,
                tamanhoPagina: 5
            },
            arquivosUploads: [],
            carsSet: [],
            carEspecificado: false,
            firstCarsSelected: [],
            carsCondicao: {},
            carByCode: '',
            geometryDesenho: '',
            carByGeometry: '',
            dialogListaCarSelect: false,
            territorioSobrePosto: false,
            territorioSobrePostoMessage: null,
            territorioInicial: {},
            layersMaps: [],
            carCodigo: null,
            carsCpfCnpj: [],
            carVinculadoCpfCnpj: null,
            mostrarModalDadosCpfCnpj: false,
            municipioBuffer: {},
            dados: {
                carEstadoPaginado: [],
                existemDados: false
            },
            tipoCertificacao: [],
            showModalCriarNovosMonitoramentos: false,
            showModalCancelarMonitoramentos: false,
            showModalErroRecriarMonitoramentos: false,
            monitoramentosComErro: [],
            tipoCadastroIsDoc: false,
            tipoCadastroIsVetor: false,
            tipoCadastroIsCarSelecionado: false,
            ff1183CodigoLyraTerritorio: this.$unleash.isEnabled(formatFlag(FeatureFlagConst.FF1183_CODIGO_LYRA_TERRITORIO))
        };
    },
    validations: {
        territorio: {
            nome: {
                required
            }
        }
    },
    mounted() {
        this.fetchTerritorios();
        this.fetchRepresentantes();
        this.fetchTipoCertificacao();

        if (this.territorioData.value === 'edit') {
            this.territorioInicial = this.territorioData.geometria;
        }

        this.$bus.$on('comercializacao', data => {
            this.territorio.comercializacoes = data;
        });

        if (this.$route.params.cadastrar) {
            this.mostrarModalEditarCadastrarRepresentante = true;
            this.editar = false;
            this.territorio.nome = this.$route.params.cadastrar;
        }

        const { getters } = this.$store;
        const representante = getters.representante;
        if (representante.id) {
            const repr = this.options.findIndex(
                item => item.id === representante.id
            );
            if (repr) {
                this.options.push({ ...representante });
            }
            if (
                this.$route.params.cadastrar === 'pessoa' ||
                this.territorioData.value === 'edit'
            ) {
                this.territorio.nome = '';
                this.territorio.representantes.push({ ...representante });
            } else {
                this.territorio.nome = '';
                this.territorio.representantes = '';
            }
        }
    },

    beforeDestroy() {
        this.setRepresentante({
            id: null,
            usuario: null,
            idUsuario: null,
            nomeRazaoSocial: null,
            cpfCnpj: null,
            idCliente: null,
            email: null,
            ativo: null,
            dataCadastro: null,
            dataAtualizacao: null,
            empresas: null,
            cpfCnpjCrypt: null
        });
        this.$store.dispatch('setLimparCamadas', true);

        this.setEdicaoSimplesTerritorio(null);

        this.setRecriarMonitoramentos([]);
    },

    created() {
        EventBus.$on(
            'mapa:desativar-se-ativo-selecao',
            this.desativarSelecaoSeAtivo
        );
        EventBus.$on('mapa:setar-car-especificado', this.setarCarEspecificado);
    },
    computed: {
        ...mapGetters([
            'territorioData',
            'isEdicaoSimplesTerritorio',
            'territoryTableData',
            'representante',
            'usuarioLogado',
            'getRecriarMonitoramentos',
            'ambienteAr'
        ]),
        pagedTableData() {
            return this.tableData.slice(
                this.pageSize * this.page - this.pageSize,
                this.pageSize * this.page
            );
        },
        tipoBotao() {
            return this.ativo ? 'default' : 'primary';
        },
        textoBotao() {
            return this.ativo
                ? this.$t('mensagens.territorio.desativarSelecaoMapa')
                : this.$t('mensagens.territorio.ativarSelecaoMapa');
        }
    },
    watch: {
        search() {
            if (!this.search) {
                this.total = this.tableData.length;
                return this.tableData;
            }
            this.page = 1;
            this.total = this.pagedTableData.length;
            return this.tableData.filter(
                data =>
                    !this.search ||
                    data.nomeRazaoSocial
                        .toLowerCase()
                        .includes(this.search.toLowerCase())
            );
        },
        territoryTableData() {
            this.fitBoundsGeometriasTabela();
        },
        carCodigo: function (value) {
            if (value && value.length > 0) {
                let mascara = '';
                value = value.replace(/[^\w\s]/gi, '');

                if (value.length <= 12) {
                    mascara = formatters.formatCarEstadualMT(value);
                } else if (value.length === 13) {
                    mascara = value;
                } else if (value.length <= 14) {
                    mascara = formatters.numeralStringFormatToDocumento(value);
                } else if (value.length > 14 && value.length <= 32) {
                    mascara = formatters.formatCodigoParcela(value);
                } else {
                    mascara = formatters.formatCar(value);
                }
                this.carCodigo = mascara;
            }
        }
    },
    methods: {
        fecharModalErroRecriarMonitoramentos() {
            this.showModalErroRecriarMonitoramentos = false;
            this.monitoramentosComErro = [];
            this.redirecionar();
        },
        fecharModalCancelarMonitoramentos() {
            this.showModalCriarNovosMonitoramentos = false;
            this.redirecionar();
        },
        verificaInputBarra(valor) {
            if (valor.includes('/')) {
                this.territorio.idCliente = valor.replace(/\//g, '');
            }
        },
        setarCarEspecificado(state) {
            this.carEspecificado = state;
        },
        closeDialog() {
            this.territorioSobrePosto = false;
        },

        ...mapActions([
            'setRepresentante',
            'setEdicaoSimplesTerritorio',
            'setTerritoryTableData',
            'clearTerritoryTableData',
            'clearTerritorio',
            'replaceTerritoryTableData',
            'removeTerritoryTableData',
            'setRecriarMonitoramentos'
        ]),

        removerTerritorio(identificadorGeometria) {
            this.territoryTableData.forEach((item, index) => {
                if (identificadorGeometria === item.identificadorGeometria) {
                    this.removeTerritoryTableData(index);
                }
            });
        },

        ignorarTodosCars(geometriaTerritorio) {
            if (this.usuarioLogado.carTerritorioObrigatorio) {
                let territoryPropertyConverionToTableData = this.territoryTableData.find(item => item.geometry.coordinates === geometriaTerritorio.coordinates);

                if (territoryPropertyConverionToTableData) {
                    this.dialogListaCarSelect = false;
                    this.modalVincularCar.mostrarModalVincularCar = true;
                    this.modalVincularCar.payload = territoryPropertyConverionToTableData;
                }
            }
        },

        fetchStates() {
            LocalidadeService.findEstados().then(({ data }) => {
                this.estados = data;
            });
        },

        deleteUploadFile(name) {
            const removeFile = this.$refs.upload.uploadFiles.filter(
                f => f.name === name
            )[0];
            this.$refs.upload.uploadFiles =
                this.$refs.upload.uploadFiles.filter(f => f.name !== name);
            this.onRemoveFile(removeFile, null);
        },

        fetchTerritorios() {
            if (this.territorioData.value === 'edit') {
                this.territorio = this.territorioData;
                this.isAdding = false;
                this.setMapGeometry();
            } else {
                this.clearAll();
                this.isAdding = true;
            }
            this.dataLoaded = true;
        },

        async buscarCarsSobrepostoTerritorio() {
            try {
                const { data } = await territorioService.findCarsByTerritorio(
                    this.territorio.geoJson
                );
                this.carsSet = [];
                data.forEach(({ codigo, condicao }) => {
                    this.carsSet.push(codigo);
                    this.carsCondicao[codigo] = condicao;
                });

                if (this.firstCarsSelected) {
                    this.firstCarsSelected.forEach(item => {
                        let index = this.carsSet.indexOf(item);
                        this.carsSet.splice(index, 1);
                    });
                }

                if (this.carsSet.length > 0) {
                    this.dialogListaCarSelect = true;
                } else {
                    this.territorio.carsVinculados = [];
                    this.salvarTerritorio();
                }
            } catch (error) {
                this.$notify.error({
                    message: get(error, 'response.data.message', error.message)
                });
            }
        },

        clearSobreposicaoTerritorio() {
            this.territorioSobrePostoMessage = null;
            this.territorioSobrePosto = false;
        },

        async addTerritorio() {
            this.$v.$touch();
            if (this.checkIfIsValid()) {
                this.territorio.geoJson = this.territoryTableData[0].geometry;
                this.firstCarsSelected =
                    this.territoryTableData[0].firstCodigos;
                this.clearSobreposicaoTerritorio();
                if (this.isIgnoreSobreposition) {
                    if (this.territoryTableData[0].type === 'CAR') {
                        this.territorio.carsVinculados = [];
                        this.territorio.carsVinculados.push(
                            this.territoryTableData[0].codigo
                        );
                        this.carsCondicao[this.territoryTableData[0].codigo] =
                            this.territoryTableData[0].situacao;

                        this.salvarTerritorio();
                    } else {
                        await this.buscarCarsSobrepostoTerritorio();
                    }
                } else {
                    territorioService
                        .validarSobreposicaoTerritorio(this.territorio.geoJson)
                        .then(async () => {
                            if (this.territoryTableData[0].type === 'CAR') {
                                this.territorio.carsVinculados = [];
                                this.territorio.carsVinculados.push(
                                    this.territoryTableData[0].codigo
                                );
                                this.carsCondicao[
                                    this.territoryTableData[0].codigo
                                ] = this.territoryTableData[0].situacao;

                                this.salvarTerritorio();
                            } else {
                                await this.buscarCarsSobrepostoTerritorio();
                            }
                        })
                        .catch(error => {
                            const message = get(
                                error,
                                'response.data.message',
                                error.message
                            );
                            this.territorioSobrePostoMessage = message;
                            this.territorioSobrePosto = true;
                        });
                }
            }
        },

        async salvarTerritorio() {
            if (this.getRecriarMonitoramentos && this.getRecriarMonitoramentos.length > 0) {
                if (this.showModalCancelarMonitoramentos) {
                    this.territorio.excluirMonitoramentos = true;
                    this.showModalCancelarMonitoramentos = false;
                } else {
                    this.showModalCancelarMonitoramentos = true;
                    return;
                }
            }

            if (!this.validarComercializacao()) {
                this.$notify.warning({
                    message: this.$t('mensagens.territorio.itemComercializacaoCampoObrigatorio')
                });
                return;
            }

            if (!this.isEdicaoSimplesTerritorio) {
                const carsVinculados = [...this.territorio.carsVinculados];
                this.territorio.carsVinculados = [];

                carsVinculados.forEach(car => {
                    this.territorio.carsVinculados.push({
                        codigo: car,
                        condicao: this.carsCondicao[car]
                    });
                });
            }

            this.territorio.validarSobreposicao = !this.isIgnoreSobreposition;

            if (this.territorioData.value === 'edit') {
                territorioService
                    .update(this.territorio)
                    .then(response => {
                        this.processarCadastrarTerritorioGoogleAnalytics('editar');
                        this.encerrarEdicao();
                    })
                    .catch(error => {
                        this.$notify.error({
                            message: get(
                                error,
                                'response.data.message',
                                error.message
                            )
                        });
                    });
            } else {
                try {
                    await territorioService.add(
                        this.territorio
                    );

                    this.isAddingOrEditingTerritorio = false;
                    this.addTerritorioSuccess = true;
                    this.territorio.representantes = [];

                    this.$notify.success({
                        message: this.$t('mensagens.territorio.territorioAdicionadoSucesso')
                    });

                    this.processarCadastrarTerritorioGoogleAnalytics('novo');
                    this.$router.push({ name: 'Territorio' });
                } catch (erro) {
                    this.$notify.error({
                        message: erro.response.data.message?.includes(
                            this.$t('mensagens.territorio.geometriaNaoValida')
                        )
                            ? this.$t('mensagens.territorio.erroCadastroTerritorioGeometriaInvalida')
                            : erro.response.data.message?.includes(
                                this.$t('mensagens.territorio.idClienteJaExiste')
                            )
                                ? this.$t('mensagens.territorio.idClienteJaExiste')
                                : this.$t('mensagens.territorio.erroAoSalvarTerritorio')
                    });
                }
            }
        },

        encerrarEdicao() {
            this.updateTerritorioModal = false;
            this.isAddingOrEditingTerritorio = false;

            if (this.territorio.excluirMonitoramentos) {
                this.showModalCriarNovosMonitoramentos = true;
            } else {
                this.$notify.success({
                    message: 'Território editado com sucesso!'
                });

                this.redirecionar();
            }
        },

        criarNovoMonitoramento() {
            this.showModalCriarNovosMonitoramentos = false;
            
            let areasMonitoradasSocioambiental = this.getRecriarMonitoramentos.filter(item => item.tipoMonitoramento.codigo === TipoMonitoramento.SOCIOAMBIENTAL);
            let areasMonitoradasAgricola = this.getRecriarMonitoramentos.filter(item => item.tipoMonitoramento.codigo === TipoMonitoramento.AGRICOLA);
            let monitoramentosRecriados;

            MonitoramentoService.recadastrarMonitoramento(areasMonitoradasSocioambiental.map(item => item.id), this.$t('mensagens.sistema.recriarMonitoramentoSocioambiental')).then(() => {
                monitoramentosRecriados = true;
                
            }).catch(() => {
                monitoramentosRecriados = false;
                this.monitoramentosComErro.push(...areasMonitoradasSocioambiental);

            }).finally(() => {
                MonitoramentoService.recadastrarMonitoramento(areasMonitoradasAgricola.map(item => item.id), this.$t('mensagens.sistema.recriarMonitoramentoAgricola')).then(() => {
                    if (monitoramentosRecriados) {
                        this.$notify.success({
                            message: this.$t('mensagens.comuns.monitoramento.monitoramentosRecriados'),
                            duration: 10000
                        });
                    }

                }).catch(() => {
                    monitoramentosRecriados = false;
                    this.monitoramentosComErro.push(...areasMonitoradasAgricola);

                }).finally(() => {
                    if (monitoramentosRecriados) {
                        this.redirecionar();

                    } else {
                        this.showModalErroRecriarMonitoramentos = true;
                    }
                });

            });
        },

        redirecionar() {
            this.fetchTerritorios();
            this.$router.push({ name: 'Territorio' });
        },

        processarCadastrarTerritorioGoogleAnalytics(tipo) {
            if (tipo === 'novo') {
                this.$store.dispatch('processarEventoGoogleAnalytics', { eventLabel: 'CADASTRAR_TERRITORIO', pageTitle: 'CADASTRAR_TERRITORIO', routeName: this.$route?.name, routePath: this.$route?.path, keyValue: this.territorio?.nome });
                if (this.tipoCadastroIsDoc) {
                    this.$store.dispatch('processarEventoGoogleAnalytics', { eventLabel: 'CADASTRO_USADO_CAR_DOC_PARCELA_INCRA', pageTitle: 'CADASTRO_USADO_CAR_DOC_PARCELA_INCRA', routeName: this.$route?.name, routePath: this.$route?.path });
                }
                if (this.tipoCadastroIsVetor) {
                    this.$store.dispatch('processarEventoGoogleAnalytics', { eventLabel: 'CADASTRO_USADO_KML_KMZ_WKT_SHAPEFILE', pageTitle: 'CADASTRO_USADO_KML_KMZ_WKT_SHAPEFILE', routeName: this.$route?.name, routePath: this.$route?.path });
                }
                if (this.tipoCadastroIsCarSelecionado) {
                    this.$store.dispatch('processarEventoGoogleAnalytics', { eventLabel: 'CADASTRO_USADO_CAR_SELECAO_MAPA', pageTitle: 'CADASTRO_USADO_CAR_SELECAO_MAPA', routeName: this.$route?.name, routePath: this.$route?.path });
                }
            } else {
                this.$store.dispatch('processarEventoGoogleAnalytics', { eventLabel: 'EDITAR_TERRITORIO', pageTitle: 'EDITAR_TERRITORIO', routeName: this.$route?.name, routePath: this.$route?.path, keyValue: this.territorio?.nome });
            }
        },

        async continuarTerritorioSobreposto() {
            this.isIgnoreSobreposition = true;
            this.clearSobreposicaoTerritorio();
            this.addTerritorio();
            this.closeDialog();
        },

        async updateTerritorio() {

            this.$v.$touch();
            if (this.checkIfIsValid()) {
                this.territorio.geoJson = this.territoryTableData[0].geometry;

                if (this.isEdicaoSimplesTerritorio) {
                    this.territorio.carsVinculados = null;
                    this.isIgnoreSobreposition = true;
                    this.salvarTerritorio();
                    return;
                }

                territorioService
                    .validarSobreposicaoTerritorio(
                        this.territorio.geoJson,
                        this.territorio.id
                    )
                    .then(async () => {
                        await this.buscarCarsSobrepostoTerritorio();

                        if (
                            this.territorioInicial === this.territorio.geoJson
                        ) {
                            this.territorio.carsVinculados = [];

                            this.territorioData.cars.forEach(
                                ({ codigo, condicao }) => {
                                    this.territorio.carsVinculados.push(codigo);
                                    this.carsCondicao[codigo] = condicao;
                                }
                            );
                        }
                    })
                    .catch(error => {
                        const message = get(
                            error,
                            'response.data.message',
                            error.message
                        );
                        this.territorioSobrePostoMessage = message;
                        this.territorioSobrePosto = true;
                        this.$notify.error({
                            message: error.response.data.mensagem?.includes(
                                'ID Cliente já existente'
                            )
                                ? 'ID Cliente já existente'
                                : 'Ocorreu um erro ao atualizar território.'
                        });
                    });
            }
        },

        findMunicipios(idEstado) {
            this.municipioSelecionado = null;
            this.municipios = null;
            if (idEstado != null) {
                LocalidadeService.findMunicipios(idEstado).then(({ data }) => {
                    this.municipios = data;
                });
            }
        },

        onLoadFile(file, fileList) {
            this.tipoCadastroIsVetor = true;
            this.$store.dispatch('processarEventoGoogleAnalytics', { eventLabel: 'INSERIR_KML_KMZ_WKT_SHAPEFILE', pageTitle: 'INSERIR_KML_KMZ_WKT_SHAPEFILE', routeName: this.$route?.name, routePath: this.$route?.path });
            let reader = new FileReader();

            let extension = file.name.split('.').pop().toLowerCase();

            reader.onload = async e => {
                geometryConverter
                    .read(extension, e.target.result, file.raw)
                    .then(geometria => {
                        this.processarGeometria(geometria, file.name);

                        let dadosArquivo = {
                            id: file.uid,
                            layer: geometria
                        };

                        this.arquivosUploads.push(dadosArquivo);
                    })
                    .catch(rejectReason => {
                        this.$refs.upload.clearFiles();
                        this.$notify.error({ message: rejectReason });
                    });
            };

            reader.readAsText(file.raw);
        },

        processarGeometria(geometria, fileName) {
            this.filtrarGeometrias(geometria);
            if (geometria !== null && geometria.getLayers().length > 0) {
                // const index = geometria.getLayers().length - 1;
                if (
                    geometria.getLayers()[0].feature.geometry.type ===
                    'GeometryCollection'
                ) {
                    _.each(geometria.getLayers()[0].getLayers(), layer =>
                        this.processarLayer(geometria, layer, fileName)
                    );
                } else {
                    _.each(geometria.getLayers(), layer => {
                        if (layer.feature.geometry.type !== 'GeometryCollection') {
                            this.processarLayer(geometria, layer, fileName);
                        }
                    }

                    );
                }
            } else {
                this.$refs.upload.clearFiles();

                this.$notify.error({
                    message: this.$t('mensagens.territorio.arquivoNaoPossuiGeometriaValida')
                });
            }
        },

        async processarLayer(geometria, layer, fileName) {
            let territoryPropertyConverionToTableData = {};
            await territorioService.calcularAreaGeometria(layer.toGeoJSON().geometry)
                .then((response) => {
                    territoryPropertyConverionToTableData.area_ha = response.data;
                });
            territoryPropertyConverionToTableData.identificadorGeometria =
                layer._leaflet_id;
            layer.identificadorGeometria = layer._leaflet_id;
            territoryPropertyConverionToTableData.type = 'UPLOAD';
            territoryPropertyConverionToTableData.codigo = 'UPLOAD';
            territoryPropertyConverionToTableData.geometry =
                layer.toGeoJSON().geometry;
            territoryPropertyConverionToTableData.fileName = fileName;

            this.setTerritoryTableData(territoryPropertyConverionToTableData);
            this.clearSobreposicaoTerritorio();

            const uploadStyle = {
                color: 'red'
            };

            geometria.setStyle(uploadStyle);

            this.$refs.mapa.mapa.addLayer(geometria);
            this.$refs.mapa.mapa.fitBounds(geometria.getBounds());

            if (this.usuarioLogado.carTerritorioObrigatorio) {
                try {
                    const { data } = await territorioService.findCarsByTerritorio(layer.toGeoJSON().geometry);
                    if (data.length === 0) {
                        this.$notify.warning({
                            message: this.$t('mensagens.territorio.erroAoLocarlizarCarTerritorio')
                        });
                        this.modalVincularCar.mostrarModalVincularCar = true;
                        this.modalVincularCar.payload = territoryPropertyConverionToTableData;
                    }
                } catch (error) {
                    this.$notify.warning({
                        message: this.$t('mensagens.territorio.erroAoLocarlizarCarTerritorio')
                    });
                    this.modalVincularCar.mostrarModalVincularCar = true;
                    this.modalVincularCar.payload = territoryPropertyConverionToTableData;
                }
            }
        },
        /* Permite apenas Features e Geometries do tipo '(Multi)Polygon' */
        filtrarGeometrias(layerGeometrias) {
            if (layerGeometrias === null) return;

            if (layerGeometrias.getLayers) {
                layerGeometrias.getLayers().forEach(layer => {
                    if (!(layer instanceof L.Polygon)) {
                        if (layer instanceof L.LayerGroup) {
                            return this.filtrarGeometrias(layer);
                        }
                        layerGeometrias.removeLayer(layer);
                    }
                });
            } else {
                if (!(layerGeometrias instanceof L.Polygon)) {
                    return L.featureGroup();
                }
            }
        },
        onRemoveFile(file, fileList) {
            let itemToRemove = _.find(this.arquivosUploads, o => {
                return o.uid === file.id;
            });

            if (itemToRemove) {
                this.$refs.mapa.mapa.removeLayer(itemToRemove.layer);
            }

            _.remove(this.arquivosUploads, o => {
                return o.uid === file.id;
            });

            const index = this.$refs.table.territoryTableData.findIndex(
                d => d.fileName === file.name
            );
            this.$refs.table.removeTerritoryTableData(index);
        },

        getFiltros(query) {
            const filtro = {};
            filtro.page = this.paginacao.paginaAtual - 1;
            filtro.size = this.paginacao.tamanhoPagina;
            filtro.searchText = query || '';
            if (validators.validarCPF(query)) {
                filtro.searchText = formatters.documentoFormatToNumeral(query);
            }
            filtro.order = '&sort=nome_razao_social,asc';
            return filtro;
        },

        async fetchRepresentantes(query) {
            try {
                const { data } = await representanteService.findAllByFiltro(
                    this.getFiltros(query)
                );
                this.loading = false;
                this.representanteData = this.representanteData.concat(
                    data.resultados
                );
                this.representanteData = this.representanteData.filter(
                    (v, i, a) => a.findIndex(t => t.id === v.id) === i
                );
                this.options = data.resultados.slice(0, 5);
                if (this.territorioData.value === 'edit') {
                    let intersection = [];
                    let difference = [];
                    this.options.forEach(value => {
                        this.territorio.representantes.forEach(item => {
                            if (item.id === value.id) {
                                intersection.push(item);
                            }
                        });
                    });
                    difference = this.territorio.representantes.filter(
                        value => !intersection.includes(value)
                    );
                    this.options.push(...difference);
                }

                if (this.representante.id) {
                    const repr = this.options.findIndex(
                        item => item.id === this.representante.id
                    );
                    if (repr) {
                        this.options.push({ ...this.representante });
                    }
                }
            } catch (e) {
                this.$notify.error({
                    message: this.$t('mensagens.territorio.erroAoBuscarPessoas')
                });
            }
        },

        async fetchTipoCertificacao() {
            try {
                const { data } =
                    await territorioService.buscarTipoCertificacao();
                this.tipoCertificacao = data;
            } catch (e) {
                this.$notify.error({
                    message: this.$t('mensagens.territorio.erroAoBuscarTiposCertificacao')
                });
            }
        },

        toggleSelecao() {
            this.tipoCadastroIsCarSelecionado = true;
            this.$store.dispatch('processarEventoGoogleAnalytics', { eventLabel: 'INSERIR_CAR_SELECAO_MAPA', pageTitle: 'INSERIR_CAR_SELECAO_MAPA', routeName: this.$route?.name, routePath: this.$route?.path });
            this.ativo = !this.ativo;
            if (this.ativo) {
                this.ativarSelecao();
            } else {
                this.desativarSelecao();
            }
        },
        desativarSelecaoSeAtivo() {
            if (this.ativo) {
                this.desativarSelecao();
                this.ativo = false;
            }
        },
        ativarSelecao() {
            this.$store.dispatch('setAtivarCamadaCar', true);
        },
        desativarSelecao() {
            this.$store.dispatch('setAtivarCamadaCar', false);
            this.territorio.geoJson = null;
            this.fitBoundsGeometriasTabela();
        },
        fitBoundsGeometriasTabela() {
            if (
                this.territoryTableData.length &&
                this.$refs &&
                this.$refs.mapa &&
                this.$refs.mapa.mapa
            ) {
                const group = new L.FeatureGroup();
                this.territoryTableData.forEach(territorioTabela => {
                    group.addLayer(L.geoJSON(territorioTabela.geometry));
                });
                this.$refs.mapa.mapa.fitBounds(group.getBounds());
            }
        },
        setMapGeometry() {
            const identificadorGeometria = new Date().getTime();

            const territoryPropertyConverionToTableData = {};
            territoryPropertyConverionToTableData.type = 'AREA_CONSOLIDADA';
            territoryPropertyConverionToTableData.codigo = 'AREA_CONSOLIDADA';
            territoryPropertyConverionToTableData.area_ha =
                this.territorioData.areaHa;
            territoryPropertyConverionToTableData.geometry =
                this.territorioData.geometria;
            territoryPropertyConverionToTableData.identificadorGeometria =
                identificadorGeometria;

            this.clearTerritoryTableData();
            this.setTerritoryTableData(territoryPropertyConverionToTableData);
            this.clearSobreposicaoTerritorio();

            this.mostrarTerritorioNoMapa(
                this.territorioData.geometria,
                identificadorGeometria
            );
        },

        mostrarTerritorioNoMapa(geometria, identificadorGeometria) {
            this.layersMaps = [];

            geometria.identificadorGeometria = identificadorGeometria;

            const layerTerritorio = {
                style: mapaEstilos.Geometria.imovelRuralCandidato,
                name: identificadorGeometria,
                geoJson: geometria
            };

            this.layersMaps.push(layerTerritorio);
        },
        clearAll() {
            this.clearTerritoryTableData();
            this.territorio.nome = null;
            this.clearTerritorio();
        },
        remoteMethod(query) {
            this.loading = true;
            setTimeout(() => {
                this.fetchRepresentantes(query);
            }, 800);
        },
        dadoJaFoiAdicionado(dado) {
            let result = false;
            if (this.territoryTableData.length === 0) {
                result = false;
            } else {
                this.territoryTableData.forEach(item => {
                    if (item.codigo === dado) {
                        result = true;
                    }
                });
            }
            return result;
        },

        async getDadosMunicipio(item) {
            const idMunicipio = item.properties.id_municipio;

            if (this.municipioBuffer[idMunicipio]) {
                return `${this.municipioBuffer[idMunicipio].nome} - ${this.municipioBuffer[idMunicipio].estado.sigla}`;
            } else {
                try {
                    const { data } = await MunicipioService.getMunicipioById(
                        idMunicipio
                    );
                    this.municipioBuffer[idMunicipio] = data;
                    return `${this.municipioBuffer[idMunicipio].nome} - ${this.municipioBuffer[idMunicipio].estado.sigla}`;
                } catch (e) {
                    this.$notify.error({
                        message: this.$t('mensagens.territorio.erroAoBuscarDadosMunicipio')
                    });
                    return '-';
                }
            }
        },

        async buscarCarPorCpfCnpjVinculado() {
            const codigo = this.carCodigo.replace(/[^\w\s]/gi, '');
            try {
                const { data: dataCar } =
                    await CarService.buscarCarPorCpfCnpjVinculado(codigo);
                const { data: listaSigef } =
                    await SigefService.consultarCpfCnpj(codigo);

                if (dataCar.existemDados || listaSigef.length) {
                    this.mostrarModalDadosCpfCnpj = true;
                    this.carVinculadoCpfCnpj = codigo;
                    this.dados = {
                        listaSigef,
                        ...dataCar
                    };
                } else {
                    this.$notify.info({
                        message: this.$t('mensagens.territorio.naoForamEncontradosDadosCpfCnpj')
                    });
                }
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.territorio.erroNaRequisicaoTenteNovamente')
                });
            }
        },

        async buscarParcelaPorINCRA() {
            try {
                const { data: listaSigef } = await SigefService.consultarINCRA(
                    this.carCodigo
                );

                if (listaSigef.length) {
                    this.mostrarModalDadosCpfCnpj = true;
                    this.carVinculadoCpfCnpj = this.carCodigo;
                    this.dados = {
                        listaSigef
                    };
                    this.carCodigo = null;
                } else {
                    this.$notify.info({
                        message: this.$t('mensagens.territorio.naoForamEncontradosDadosNumeroIncra')
                    });
                }
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.territorio.erroNaRequisicaoTenteNovamente')
                });
            }
        },

        findCarByCode() {
            let codigo = this.carCodigo.replace(/[^\w\s]/gi, '');
            const isCarEstadual = this.carCodigo.startsWith('MT') && this.carCodigo.indexOf('-') === -1;
            CarService
                .findByCodigos(Array(this.carCodigo))
                .then(response => {
                    if (response.status === 200) {
                        let type = 'CAR';

                        let responseData = response.data.data[0];

                        let resultado = {
                            ...responseData,
                            area_ha: responseData.areaHaCalculada,
                            geometry: responseData.geometria,
                            nome_municipio: responseData.nomeMunicipio,
                            type,
                            identificadorGeometria: codigo
                        };

                        if (isCarEstadual) {
                            type += ' Estadual';

                            resultado.type = type;
                        }

                        this.mostrarTerritorioNoMapa(resultado.geometria, codigo);

                        if (!this.dadoJaFoiAdicionado(resultado.codigo)) {
                            this.setTerritoryTableData(resultado);
                        } else {
                            this.$notify.error({
                                message: this.$t('mensagens.territorio.carJaSelecionado')
                            });
                        }
                        this.carCodigo = null;
                        this.carEspecificado = true;
                    } else {
                        this.$notify.error({
                            message: this.$t('mensagens.territorio.erroConsultarCarInserido')
                        });
                    }
                })
                .catch((e) => {
                    this.$notify.error({
                        message: this.$t('mensagens.territorio.erroConsultarCarInserido')
                    });
                });
        },
        findCar() {
            this.tipoCadastroIsDoc = true;
            this.$store.dispatch('processarEventoGoogleAnalytics', { eventLabel: 'INSERIR_CAR_DOC_PARCELA_INCRA', pageTitle: 'INSERIR_CAR_DOC_PARCELA_INCRA', routeName: this.$route?.name, routePath: this.$route?.path });
            if (this.carCodigo) {
                this.carsCpfCnpj = [];
                let codigo = this.carCodigo.replace(/[^\w\s]/gi, '').length;

                if ((codigo === 11 && this.carCodigo.substring(0, 2) !== 'MT') || codigo === 14) {
                    this.buscarCarPorCpfCnpjVinculado();
                } else if (this.carCodigo.length === 36) {
                    this.buscarSigefPorCodigoParcela();
                } else if (this.carCodigo.length === 13 && this.carCodigo.substring(0, 2) !== 'MT') {
                    this.buscarParcelaPorINCRA();
                } else {
                    this.findCarByCode();
                }
            } else {
                this.$notify.error({
                    message: this.$t('mensagens.territorio.inforCarCpfCnpjValido')
                });
            }
        },
        adicionarDadosSelecionadosNaModalNoMapa(dadosSelecionados) {
            this.mostrarModalDadosCpfCnpj = false;
            this.layersMaps = [];

            Object.keys(dadosSelecionados).forEach(conjunto => {
                if (conjunto === 'sigef') {
                    dadosSelecionados[conjunto].forEach(
                        async ({ codigoParcela }) => {
                            const { data } =
                                await SigefService.buscarGeometriaParcela(
                                    codigoParcela
                                );

                            const geometriaParcela = JSON.parse(data);

                            const resultado = {
                                codigo: codigoParcela,
                                identificadorGeometria: codigoParcela,
                                type: 'Parcela Incra',
                                geometry: geometriaParcela,
                                area_ha:
                                    geometryUtils.calcularAreaHaFromGeoJSON(
                                        geometriaParcela
                                    )
                            };

                            this.mostrarTerritorioNoMapa(
                                geometriaParcela,
                                resultado.identificadorGeometria
                            );

                            if (!this.dadoJaFoiAdicionado(codigoParcela)) {
                                this.setTerritoryTableData(resultado);
                            }
                        }
                    );
                } else {
                    dadosSelecionados[conjunto].forEach(async ({ codigo }) => {
                        const { data } = await CarService.buscarGeometria(
                            codigo
                        );

                        const { data: areaHaCalculada } = await territorioService.calcularAreaGeometria(data);
                        let resultado = {
                            codigo,
                            identificadorGeometria: codigo,
                            type: 'CAR',
                            geometry: data,
                            area_ha: areaHaCalculada
                        };

                        this.mostrarTerritorioNoMapa(
                            data,
                            resultado.identificadorGeometria
                        );

                        if (!this.dadoJaFoiAdicionado(codigo)) {
                            this.setTerritoryTableData(resultado);
                        }
                    });
                }
            });

            this.carCodigo = null;
        },
        handleChangeSelectInput() {
            this.$nextTick(() => {
                this.$refs.elselectinput.query = '';
            });
        },
        checkIfIsValid() {

            if (this.$v.$invalid || this.territoryTableData.length !== 1) {
                if (this.$v.$invalid) {
                    this.$notify.error({
                        message: this.$t('mensagens.territorio.verifiqueCamposObrigatorios')
                    });
                    return false;
                }
                if (
                    this.territoryTableData.length !== 1 &&
                    !this.isEdicaoSimplesTerritorio
                ) {
                    setTimeout(() => {
                        this.$notify.error({
                            message: this.$t('mensagens.territorio.verifiqueTerritoriosConsolidados')
                        });
                    }, 200);
                    return false;
                }
            }
            if (this.territorioSobrePostoMessage) {
                this.territorioSobrePosto = true;
                return false;
            }

            return true;
        },
        async adicionarDesenho(desenho) {
            let territoryPropertyConverionToTableData = {};
            territoryPropertyConverionToTableData.identificadorGeometria =
                desenho._leaflet_id;
            desenho.identificadorGeometria = desenho._leaflet_id;

            territoryPropertyConverionToTableData.type = 'Desenho de geometria';
            territoryPropertyConverionToTableData.codigo = 'DESENHO';
            territoryPropertyConverionToTableData.area_ha =
                geometryUtils.calcularAreaHaFromLayer(desenho);
            territoryPropertyConverionToTableData.geometry =
                desenho.toGeoJSON().geometry;

            this.geometryDesenho = desenho.toGeoJSON().geometry;
            this.setTerritoryTableData(territoryPropertyConverionToTableData);
            this.clearSobreposicaoTerritorio();

            if (this.usuarioLogado.carTerritorioObrigatorio && !this.ambienteAr) {
                try {
                    const { data } = await territorioService.findCarsByTerritorio(desenho.toGeoJSON().geometry);
                    if (data.length === 0) {
                        this.$notify.warning({
                            message: this.$t('mensagens.territorio.naoFoiPossivelLocalizarCarTerritorio')
                        });
                        this.modalVincularCar.mostrarModalVincularCar = true;
                        this.modalVincularCar.payload = territoryPropertyConverionToTableData;
                    }
                } catch (error) {
                    this.$notify.warning({
                        message: this.$t('mensagens.territorio.naoFoiPossivelLocalizarCarTerritorio')
                    });
                    this.modalVincularCar.mostrarModalVincularCar = true;
                    this.modalVincularCar.payload = territoryPropertyConverionToTableData;
                }
            }
        },
        desenhosAlterados(desenhosAlterados) {
            desenhosAlterados.eachLayer(layer => {
                const areaHa = geometryUtils.calcularAreaHaFromLayer(layer);
                const geometry = layer.toGeoJSON().geometry;
                this.territoryTableData.findIndex(
                    t => t.identificadorGeometria === layer._leaflet_id
                );
                this.replaceTerritoryTableData({
                    identificadorGeometria: layer._leaflet_id,
                    geometry,
                    areaHa
                });
            });
        },

        savarCarsVinculados(carsVinculados) {
            this.territorio['carsVinculados'] = [...carsVinculados];
            this.dialogListaCarSelect = false;
            this.salvarTerritorio();
        },

        validarComercializacao() {
            let valido = true;
            if (this.territorio.comercializacoes) {
                for (
                    var i = 0;
                    i < this.territorio.comercializacoes.length;
                    i = i + 1
                ) {
                    if (
                        !this.territorio.comercializacoes[i].produto.id ||
                        this.territorio.comercializacoes[i].quantidade === 0 ||
                        !this.territorio.comercializacoes[i].unidadeMedida.id
                    ) {
                        valido = false;
                    }
                    if (
                        !this.territorio.comercializacoes[i].produto.id &&
                        this.territorio.comercializacoes[i].quantidade === 0 &&
                        !this.territorio.comercializacoes[i].unidadeMedida.id &&
                        i === 0
                    ) {
                        valido = true;
                    }
                }
            }
            return valido;
        },

        async buscarSigefPorCodigoParcela() {
            const { data } = await SigefService.buscarGeometriaParcela(
                this.carCodigo
            );

            const geometriaParcela = JSON.parse(data);

            if (data === '') {
                this.$notify.warning(
                    this.$t('mensagens.territorio.erroParcelaInseridaNaoEncontrada')
                );
                return;
            }

            const resultado = {
                codigo: this.carCodigo,
                identificadorGeometria: this.carCodigo,
                type: 'Parcela Incra',
                geometry: geometriaParcela,
                area_ha:
                    geometryUtils.calcularAreaHaFromGeoJSON(geometriaParcela)
            };

            this.mostrarTerritorioNoMapa(
                geometriaParcela,
                resultado.identificadorGeometria
            );

            if (!this.dadoJaFoiAdicionado(this.carCodigo)) {
                this.setTerritoryTableData(resultado);
            }
            this.carCodigo = null;
        },

        internacionalizarMensagens(message) {
            if (!message) {
                return '';
            }
            const partes = message.split('\n');
            const territoriosSobrepostos = partes.slice(1, -1).join('\n').trim();
            const mensagemSobreposicao = this.$t('mensagens.territorio.avisoSobreposicaoTerritorios');
            const mensagemConfirmarSobreposicao = this.$t('mensagens.territorio.confirmarCadastroSobreposto');

            return `${mensagemSobreposicao}\n ${territoriosSobrepostos}\n${mensagemConfirmarSobreposicao}`;
        }
    }
};
</script>

<style lang='scss' scoped>
.cadastro-territorio {
    display: flex;
    flex-direction: column;

    button {
        width: fit-content;
        cursor: pointer;
    }

    .required-text {
        color: var(--danger);
    }

    .m-25 {
        margin-top: 25px;
    }
}

.posicao-botao {
    display: flex;
    justify-content: space-between;
}

.formContainer {
    background-color: var(--white);
    border-radius: 5px;
    padding: 20px;
}

.el-upload {
    flex: 1;

    .el-icon-upload {
        font-size: 40px;
        margin: 0px;
    }
}

.el-collapse-item {
    border-bottom: 1px solid #ebeef5;
}

.el-upload-dragger {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center !important;
    justify-content: center !important;
    flex-direction: column !important;
}

.el-form-item__label {
    margin-bottom: 0px;
}

.left .el-tooltip__popper,
.right .el-tooltip__popper {
    padding: 8px 10px;
}

.voltar {
    cursor: pointer;
    line-height: 2;
}

.mapa {
    border-radius: 4px;
    overflow: hidden;
}

.btn-selecao-mapa-body {
    display: flex;
    justify-content: center;
    align-items: center;

    i {
        margin-right: 5px;
    }
}

.pre-formatted {
    white-space: pre-line;
    word-break: break-word;
}

.form-size {
    width: 100%;
}

.form-alignment {
    display: flex;
    align-items: center;
}

.separator {
    margin-right: 20px;
}
</style>

<style lang='scss'>
.menu-lateral-bg {
    background-color: var(--primary) !important;
    height: 100%;
    box-shadow: -11px 3px 33px -8px rgba(0, 0, 0, 0.25);
    padding-left: 8px;
}

#botao-ferramentas>span>.el-icon-s-tools {
    margin-top: -5px;
    margin-left: -8px;

    &::before {
        font-size: 20px;
    }
}
</style>
